export default "__VITE_ASSET__DfmPEL0L__"